module.exports = __webpack_public_path__ + "static/media/freeMinds.fcfe0cc5.jpg";